import { render } from "./FloatingChatComponent.vue?vue&type=template&id=08bc3b8a&scoped=true"
import script from "./FloatingChatComponent.vue?vue&type=script&lang=js"
export * from "./FloatingChatComponent.vue?vue&type=script&lang=js"

import "./FloatingChatComponent.vue?vue&type=style&index=0&id=08bc3b8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bc3b8a"]])

export default __exports__